module.exports = __webpack_public_path__ + "img/wp8.080c1ad2.jpeg";